import {Props} from './model';
import {TouchableOpacity, View} from 'react-native';
import * as React from 'react';
import {Text} from '../../../../../../shared/components/text';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {useTheme} from '../../../../../../shared/theme';
import {DeviceSize} from '../../../../../../shared/theme/helpers';

export default ({label, icon, iconWidth = 24, iconHeight = 24, onPress, testIdPrefix = 'icon-link-login'}: Props) => {
  const theme = useTheme();
  const styles = useStyles(({mediaOnly}) => ({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    icon: {
      marginRight: label ? 11 : 0,
      color: theme.color.whiteTextColor,
    },
    label: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h5Light,
          minWidth: 180,
        },
        theme.fonts.h6Light,
      ),
      color: theme.color.whiteTextColor,
      lineHeight: 24,
    },
  }));
  const Icon = icon;
  return (
    <TouchableOpacity testID={`${testIdPrefix}-container-id`} onPress={onPress} style={styles.container}>
      {!icon ? null : (
        <View style={styles.icon}>
          <Icon width={iconWidth} height={iconHeight} color={theme.color.whiteTextColor} />
        </View>
      )}
      {label ? (
        <Text testID={`${testIdPrefix}-label-id`} style={styles.label} numberOfLines={1}>
          {label}
        </Text>
      ) : null}
    </TouchableOpacity>
  );
};
